(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    const root = document.querySelector('.cart-items-component');
    if (!root) return;
    const raw = root.dataset.contractid;
    let contractId;
    if (raw && raw !== 'null' && raw !== 'undefined') {
      try {
        const v = JSON.parse(raw);
        contractId = (v && typeof v === 'object' && 'value' in v) ? v.value : v;
      } catch (_) { /* noop */ }
    }
    if (!contractId) return;

    const label = `契約コード：${contractId}`;
    const warning = '↓こちらのコードは削除しないようお願いいたします';
    const hasExactLine = (text, line) => {
      const lines = (text || '').split(/\r?\n/);
      return lines.some((l) => l.trim() === line);
    };
    const hasLabel = (text) => hasExactLine(text, label);
    const hasWarning = (text) => hasExactLine(text, warning);
    const mergeAppend = (text) => {
      const current = text || '';
      // Remove legacy lines (old bracket tag and old Japanese label)
      const cleanedLegacy = current
        .replace(/^[ \t]*\[contractid:\s*.*?\][ \t]*(\r?\n)?/gm, '')
        .replace(/^[ \t]*契約コード：.*(\r?\n)?/gm, '');
      let base = cleanedLegacy.replace(/\s+$/,'');
      // Append missing warning and label at the end (in this order), preserving any existing ones
      const needWarning = !hasWarning(base);
      const needLabel = !hasLabel(base);
      if (!needWarning && !needLabel) return base || '';

      const linesToAppend = [];
      if (needWarning) linesToAppend.push(warning);
      if (needLabel) linesToAppend.push(label);

      if (!base) return linesToAppend.join('\n');
      // ensure two blank lines before the block we append
      return `${base}\n\n${linesToAppend.join('\n')}`;
    };

    const syncTextarea = (val) => {
      const ta = document.querySelector('textarea[name="note"]');
      if (ta && typeof val === 'string') ta.value = val;
    };

    // Auto update note on cart page load
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }})
      .then(r => r.json())
      .then(cart => {
        const current = cart.note || '';
        const newNote = mergeAppend(current);
        if (newNote === current) { syncTextarea(current); return; }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: newNote })
        }).then(() => syncTextarea(newNote));
      })
      .catch(() => {});

    // Ensure merge before checkout submit/click
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.id === 'cart-form' || (form.action && form.action.includes('/cart'))) {
        const ta = form.querySelector('textarea[name="note"]') || document.querySelector('textarea[name="note"]');
        if (ta) ta.value = mergeAppend(ta.value || '');
      }
    }, true);

    document.addEventListener('click', (e) => {
      const el = e.target.closest('button[name="checkout"], button[data-role="checkout"], a[href^="/checkout"]');
      if (!el) return;
      const ta = document.querySelector('textarea[name="note"]');
      if (ta) ta.value = mergeAppend(ta.value || '');
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
